import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
      return (_openBlock(), _createElementBlock("button", {
        key: locale,
        onClick: ($event: any) => (_ctx.changeLocale(locale)),
        class: _normalizeClass(["ml-6 first:ml-0 uppercase font-medium flex animate-underline-tertiary", { 'text-tertiary': _ctx.currentLocale === locale }]),
        "aria-label": _ctx.$t(`aria.${locale}`)
      }, _toDisplayString(locale), 11, _hoisted_2))
    }), 128))
  ]))
}